import {EmblaIcon} from "../emblaIcon/emblaIcon";
import {SlideIn} from "../slideIn/slideIn";
import {Localizer} from "../../../infrastructure/localization/localizer";
import React from "react";
import DynamicButton from "../button/dynamicButton";
import {setSlideinState, SlideInStateEnum} from "../slideIn/slideInSlice";
import {useAppDispatch} from "../../../app/hooks";

type MobileFilterProps = {
    id: string;
    title: string;
    content: any;
    filterCount: number;
}

export function MobileFilter({filterCount = 0, ...props}: MobileFilterProps) {
    const slideInId = props.id + "mobile-filter-slideIn"
    const dispatch = useAppDispatch();

    const filterContent = () => {
        return <div className={"flex-space-around"}>
            {props.content}
            <div className="modal-actions">
                <DynamicButton
                    data-dismiss="modal"
                    onClick={() => {
                        dispatch(setSlideinState({state: SlideInStateEnum.Closing, slideInId: slideInId}))
                    }}
                    additionalClasses="margin-right-m btn-primary"
                    isIconButton={false}
                    disableMobileClasses>
                    {Localizer.forloebOverviewPage_anvendFilter()}
                </DynamicButton>
            </div>
        </div>
    }

    return (
        <>
            <button 
                className={`btn ${filterCount > 0 ? "btn-primary" : "btn-default"}`} 
                data-toggle="modal" 
                data-target={`#${slideInId}`} 
                onClick={() => dispatch(setSlideinState({state: SlideInStateEnum.Opened, slideInId: slideInId}))}
            >
                {filterCount}
                <EmblaIcon iconName="filter"/>
            </button>

            <SlideIn
                id={slideInId}
                title={props.title}
                bodyContent={filterContent()}
                defaultOpen={false}
            />
        </>
    );
}
